import React from 'react';
import PropTypes from 'prop-types';
import FavoritingHeartAnimation from './animation/FavoritingHeartAnimation';
import FavoritingHeartStyles from './FavoritingHeart.styled';
import { cn } from '@utils/cn';

const FavoritingHeart = ({
  isFavorited,
  onClick,
  className = '',
  ...props
}) => {
  return (
    <FavoritingHeartStyles
      className={cn('favoriting-heart-container', className)}
      onClick={onClick}
      {...props}
    >
      <FavoritingHeartAnimation isFavorited={isFavorited} />
    </FavoritingHeartStyles>
  );
};

FavoritingHeart.propTypes = {
  isFavorited: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default FavoritingHeart;
